import Axios from "axios";

import {
  SET_MARKET_LIST,
  UNSET_MARKET_LIST,
} from "@/store/mutation-types";

import {
  getMarketList,
  saveUpdateMarket,
} from "@/store/api";

// initial state
const state = {
  getMarketList: [],
};

const getters = {
  getMarketList(state) {
    return state.getMarketList;
  },
};

const mutations = {
  [SET_MARKET_LIST](state, data) {
    state.getMarketList = data;
  },

  [UNSET_MARKET_LIST](state) {
    state.getMarketList = [];
  },
};

const actions = {

  saveUpdateMarket({ commit }, data) {

    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {

      Axios.post(saveUpdateMarket, data)

        .then(function (response) {
          resolve(response);
        })

        .catch(function (error) {
          reject(error);
        })

        .then(() => {
          commit("UNSET_LOADING");
        });

    });
  },

  getMarketList({ commit }, data) {

    return new Promise((resolve, reject) => {

      Axios.post(getMarketList, data)

        .then(function (response) {

          commit("SET_MARKET_LIST", response.data.data);

          resolve(response);
        })

        .catch(function (error) {

          commit("UNSET_MARKET_LIST");

          reject(error);
        });

    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};